import { FunctionComponent, useRef } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { classNames } from "primereact/utils";

import "./ThreadItem.scss";

import { TooltipWrapper } from "../../../../components/Shared/Components/TooltipWrapper/TooltipWrapper";
import { translationKeys } from "../../../../models/app-translation-keys";
import { ChatThreadExtendedModel } from "../../../../models/interfaces";
import { useStore } from "../../../../stores/StoreContext";

interface IThreadItemProps {
  thread: ChatThreadExtendedModel;
  isActive: boolean;
}

const RawThreadItem: FunctionComponent<IThreadItemProps> = (props: IThreadItemProps) => {
  const { t } = useTranslation();
  const { threadStore } = useStore();
  const { visibleToUser, threadSummary } = props.thread;

  const threadSummaryRef = useRef(null);

  const selectActiveThread = (thread: ChatThreadExtendedModel) => {
    threadStore.setActiveThread(thread);
  };

  return (
    <div
      className={classNames("thread-item sidebarThreadSummaryTooltip p-ripple", {
        "is-active": props.isActive,
      })}
      onClick={() => selectActiveThread(props.thread)}
      tabIndex={0}
      onKeyDown={event => event.key === "Enter" && selectActiveThread(props.thread)}
      role="button"
    >
      <TooltipWrapper targetRef={threadSummaryRef} content={threadSummary} showDelay={300} />

      <div className="thread-item-summary" ref={threadSummaryRef}>
        <div
          className={classNames("thread-item-label", {
            deleted: !visibleToUser,
          })}
        >
          {threadSummary?.length ? (
            threadSummary
          ) : (
            <span className="no-summary-available">{t(translationKeys.thread.error.noSummaryAvailable)} </span>
          )}
        </div>
      </div>
    </div>
  );
};

export const ThreadItem = observer(RawThreadItem);
